import { useCallback } from 'react';
import { useScrollGroupContext } from './context.mjs';
import { useScrollGroupSetScroll } from './useScrollGroupSetScroll.mjs';
"use strict";
function useScrollGroupTo() {
  const {
    scrollGroupItemsRef,
    currentManualScrollMetaRef
  } = useScrollGroupContext();
  const setGroupScroll = useScrollGroupSetScroll();
  return useCallback(offset => {
    currentManualScrollMetaRef.current = {
      target: offset
    };
    const markScrollAsComplete = () => {
      if (currentManualScrollMetaRef.current?.target === offset) {
        currentManualScrollMetaRef.current = null;
        const firstElement = scrollGroupItemsRef.current?.[0]?.refObject?.current;
        if (firstElement) {
          setGroupScroll({
            top: firstElement.scrollTop,
            left: firstElement.scrollLeft
          });
        }
      }
    };
    scrollGroupItemsRef.current?.forEach(item => {
      const element = item.refObject.current;
      if (element) {
        element.scrollTo(offset);
      }
    });
    setTimeout(() => {
      markScrollAsComplete();
    }, 400);
  }, [currentManualScrollMetaRef, scrollGroupItemsRef, setGroupScroll]);
}
export { useScrollGroupTo };
//# sourceMappingURL=useScrollGroupTo.mjs.map
